import { fetchRequest, errorUtil } from '@app/util'

const query = `mutation OrganizationTransferGroupCreate(
  $organization: ID!,
  $data: TransferGroupOrganizationInput!
) {
  organizationTransferGroupCreate(
    organization: $organization,
    data: $data) {
      id
      name
      workspaces {
        workspaceId
      }
    }
}`

async function requestOrganizationTransfersGroupCreate (variables, token) {
  const response = await fetchRequest({ query, variables, token })
  if (!response) return errorUtil.noResponse()

  const { errors, data } = await response
  if (errors) {
    return errorUtil.apiError('organization', errors)
  }
  return data.organizationTransferGroupCreate
}

export default requestOrganizationTransfersGroupCreate
